import { Label, FormGroup, Textarea } from 'idsk-react-components';
import React, { ReactElement, useEffect, useState } from 'react';
import useFieldErrorMessages from '../../useFieldErrorMessages';
import AddVyhodnotenie from '../../../model/pripomienka/AddVyhodnotenie';
import { SafeParameterSetter } from '../../../types/SafeParameterSetter';

interface Props {
  textFromDetail?: string;
  updateField: SafeParameterSetter<AddVyhodnotenie>;
}

const VyhodnotenieText = ({ textFromDetail, updateField }: Props): ReactElement => {
  const {
    getFieldErrorMessage,
    clearFieldErrorMessage,
  } = useFieldErrorMessages();

  const [text, setText] = useState(textFromDetail === null ? '' : textFromDetail);

  useEffect(() => {
    updateField('textVyhodnotenia', text);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text]);

  const onTextChange = (e): void => {
    const { value } = e.target;
    setText(value);
    updateField('textVyhodnotenia', value);
    clearFieldErrorMessage('textVyhodnotenia');
  };

  return (
    <FormGroup error={!!getFieldErrorMessage('textVyhodnotenia')}>
      <Label htmlFor="text-vyhodnotenia">Text vyhodnotenia</Label>
      <Textarea
        id="text-vyhodnotenia"
        rows={7}
        maxLength={65000}
        name="text-vyhodnotenia"
        error={getFieldErrorMessage('textVyhodnotenia')}
        value={text}
        onChange={onTextChange}
      />
    </FormGroup>
  );
};

export default VyhodnotenieText;
